module.exports = __webpack_public_path__ + "img/phone_missed.b3d2cfe4.svg";